const esb = require('elastic-builder');

//const { Client } = require('@elastic/elasticsearch')
//const client = new Client({ node: 'http://localhost:9200' })


const btRecherche = document.querySelector('.recherche__loupe')
const txtRecherche = document.querySelector('.recherche__description')
const sectionRecherche = document.querySelector('.section-recherche')
const input = document.querySelector('#recherche')
const themes = document.querySelectorAll('.choix-theme')
const types = document.querySelectorAll('input[name="type"]')
const tri = document.querySelectorAll('.choix-tri')
const zoneTags = document.querySelector('.zone-tags')
const nbrSelect = document.querySelector('.select__nbr')
const nbrTotal = document.querySelector('.recherche__nbr')
const templateTag = document.querySelector("#template-tag")
const form = document.querySelector('#form-recherche')
const champsRecherche = ["title^15", "recherche^10","rendered_thematiques^5", "rendered_node"]
const header = document.querySelector('.recherche__header')
const loader = document.querySelector('.loader')

// const urlRequete = "http://localhost:9200/elasticsearch_index_imv4_index_local/_search"
//const pass = 'elastic:nErrrpPxlzIvv_dI7rye' // local 

// const urlRequete = "http://w23.institutmontaigne.org:9200/elasticsearch_index_im_2023_index_local/_search"
// const pass = 'elastic:Ervba=rVA6gRO_OBOHcT' // distant 


const urlRequete = "https://www.institutmontaigne.org:9200/elasticsearch_index_im_2023_index_local/_search"
const pass = 'elastic:Ervba=rVA6gRO_OBOHcT' // distant 

const zonePagination = document.querySelector('.section-pagination .container')
  
const matricePublications = [0,1,6,7,12,13]
const matriceExpressions = [0,1,8,9]

const nbrTypes = new Array()
nbrTypes['publications'] = 14
nbrTypes['expressions'] = 16
nbrTypes['experts'] = 200

const labelTypes = new Array()
labelTypes['publications'] = 'publication'
labelTypes['expressions'] = 'article'
labelTypes['experts'] = 'person'

const sectionsResultats = document.querySelectorAll('.section-resultat')
const zoneResultats = document.querySelectorAll('.resultat-recherche')
const zoneTerme = document.querySelector('.recherche__terme')

const liensTout = document.querySelectorAll('.lien-tout')

let page = 0

let oldRecherche = ''

let url = ''
let urlParams = ''
let urlRecherche = ''
let langueTheme = ''
let  urlRedirect =  ''

if (langue == 'fr') {
  urlRecherche = '/recherche'
  //urlRedirect = 'https://www.institutmontaigne.org/recherche'
}
else {
  urlRecherche = '/en/search'
  langueTheme = '_en'
 // urlRedirect = 'https://www.institutmontaigne.org/en/search'
}


export const init = function () {

  masqueLiensTout()


  
  
  // récupérer l'url active
  url = new URL(window.location.href)
  urlParams = new URLSearchParams(url.search);

  // Detection recherche automatique
  if (url.pathname == urlRecherche) {
    // activer la page de recherche
    sectionRecherche.classList.add('is-active')
    
    input.value = urlParams.get('s')

    if ( urlParams.get('type') ) {
        document.querySelector("#radio_"+urlParams.get('type') ).checked = true;
    }

    if ( urlParams.get('page') ) {
      page = urlParams.get('page')
    }
    
    if ( urlParams.get('tri') ) {
      tri.forEach(choix => {
        choix.classList.remove('is-active')
      }) 
      document.querySelector('.choix-tri[data-choix="'+urlParams.get('tri')+'"]').classList.add('is-active')
    }

    if ( urlParams.get('themes')  )  {
        var tempThemes = JSON.parse(urlParams.get('themes'))
        tempThemes.forEach(element => {
            
            selectTheme(element, true, document.querySelector('[data-id-theme="'+element+'"]').parentNode.querySelector('.choix-theme__label').innerHTML)
            document.querySelector('[data-id-theme="'+element+'"]').checked = true
        });
        
    }



    // On est sur lap age de recherhce donc init des clicks

  // Click sur un thème
  if (themes) {
    themes.forEach(element => {
      element.addEventListener('click', function (e) {
        // Sélection du thème
        selectTheme(e.target.dataset.idTheme, e.target.checked, e.target.parentNode.querySelector('.choix-theme__label').innerHTML)

      })
    });
  }

  // Click sur un type
  if (types) {
    types.forEach((elem) => {
      elem.addEventListener("change", function (event) {
        if( input.value.length > 0) recherche()
      });
    });
  }

  // choix Tri
  if (tri) {
    tri.forEach(element => {
      element.addEventListener('click', function (e) {
        
        tri.forEach(choix2 => {
          choix2.classList.remove('is-active')
        }) 
        e.target.classList.add('is-active')
        
        if( input.value.length > 0) recherche()
      })
    });
  }

    // Pagination
   zonePagination.addEventListener('click', function (e) {
    e.preventDefault()
      if ( e.target.classList.contains('pagination_page') &&  !e.target.classList.contains('is-active') ) {
        var choixPage = e.target.dataset.page
        page = choixPage
        recherche()
      }
      else if ( e.target.classList.contains('pagination__prev')  ) {
        page --
        recherche()
      }
      else if ( e.target.classList.contains('pagination__next')  ) {
        page ++
        recherche()
      }
  })

  // Tout voir 
  liensTout.forEach(element => {
    element.addEventListener('click', function (e) {
      e.preventDefault()
      var typeTout = e.target.dataset.type

      document.querySelector("#radio_"+typeTout ).checked = true;
      recherche()
    })
  })
  


    // lancer la recherche
    if( input.value.length > 0) recherche()
  }

  // 
  
  form.addEventListener('submit', event => {
    event.preventDefault()
    testPage()
  })
  

  // Initialisation des actions
  // Bouton rechercher
   btRecherche.addEventListener('click', function (e) {
    e.preventDefault()
    testPage()
  })
   txtRecherche.addEventListener('click', function (e) {
    e.preventDefault()
    testPage()
  })
  

  
  

}


const testPage = function () {
     // Si section recherche ouverte, on redirige sur la page de recherche 
     if (sectionRecherche.classList.contains('is-active') && (input.value.length > 0)) redirectRecherche()
     else {
       sectionRecherche.classList.add('is-active')
       input.focus()
     }
}

const selectTheme = function (idTheme, ajoute, label) {
  // Ajout des tags
  if (ajoute) {
    const tag = templateTag.content.cloneNode(true);
    tag.querySelector('.tag__label').innerHTML = label
    tag.querySelector('.tag').dataset.theme = idTheme

    tag.querySelector('.tag__close').addEventListener('click', function (e) {
      selectTheme(idTheme, false, '')
    })

    zoneTags.appendChild(tag);
  } else {
    // enlever le tag
    if (document.querySelector('.tag[data-theme="' + idTheme + '"]')) document.querySelector('.tag[data-theme="' + idTheme + '"]').remove()
    // décocher la checkbox
    document.querySelector('.choix-theme[data-id-theme="' + idTheme + '"]').checked = false
  }

  if( input.value.length > 0) recherche()
}


const redirectRecherche = function () {

  // Si sur la page de recherche : lancer une recherche
  if (comparePath(url.pathname, urlRecherche)) {
    recherche()
  }
  // Si sur une autre page : rediriger sur la page de recherche
  else {

    window.location.href = urlRecherche + '?s=' + input.value
  }
}


const masqueLiensTout = function () {

  liensTout.forEach(element => {
    element.classList.remove('is-active')
  });
}

const isPageRecherche = function () {
  console.log(url.pathname)
  if (JSON.stringify(urlRecherche) == JSON.stringify(url.pathname)) return true
  else return false
}

const comparePath = function (path1, path2) {
  var path1Dir = path1.substring(path1.lastIndexOf('/'));
  var path2Dir = path2.substring(path2.lastIndexOf('/'));
  return path1Dir == path2Dir;
}


const recherche = function () {
  

  header.classList.add('is-active')
  loader.classList.add('is-active')

  var size = 0
  var from = 0

  if ( oldRecherche !=  input.value) {
    oldRecherche =  input.value
    page = 0 
    // TODO RESET DES FILTRES -> N?OUVELLE RECHERCHE
  }
  
  // Maj label recherceh
  zoneTerme.innerHTML = '“' + input.value + '”'

  // Thèmes sélectionnés
  const themesCheck = document.querySelectorAll('.choix-theme:checked')
  var themes = new Array()
  themesCheck.forEach(element => {
    themes.push(element.dataset.idTheme)
  });

  // Maj du nbr de thèems sélectionéns
  if (themesCheck.length > 0) nbrSelect.innerHTML = '(' + themesCheck.length + ')'
  else nbrSelect.innerHTML = ''


  // Types sélectionnés
  var type = document.querySelector('input[name="type"]:checked').value

console.log('type',type)

  // Ordre
  var tri = document.querySelector('.choix-tri.is-active').dataset.choix
  var ordre = null
  var ordreChamp = null
  
  if (type =='experts') {
    tri == 'pertinence'
    ordreChamp = '_score'
    ordre = 'desc'
  } else {
    if (tri == 'pertinence' ) {
      ordre = 'desc'
      ordreChamp = '_score'
    } else {
      ordre = tri
      ordreChamp = 'created'
    }
  }

  // Mise à jour URL

    let  newUrl = new URL(url.origin + urlRecherche);
    newUrl.searchParams.append("s", input.value)
    newUrl.searchParams.append("tri", tri)
    newUrl.searchParams.append("type", type)
    newUrl.searchParams.append("themes", JSON.stringify(themes))
    newUrl.searchParams.append("page",from)

    const stateObj = { foo: "bar" };
    history.pushState(stateObj, "", newUrl.href);

  // Vider et masquer les zones de résultat
  zoneResultats.forEach(element => {
    element.innerHTML = ''
  });
  sectionsResultats.forEach(element => {
    element.classList.remove('is-active')
  })


  


  if (type == 'all') {
    // 3 Requettes

    // 6 publications
    // 5 expressions
    // 8 experts (ou tout) ?

    var totalAll = 0

    zonePagination.innerHTML = ''
    from = 0

    let boolQuery1 = esb.boolQuery().must(esb.multiMatchQuery(champsRecherche, input.value).type('best_fields').operator('and'));
    boolQuery1 = filtrerRequete(boolQuery1, themes, 'publications', 'initiatives')
    boolQuery1.filter(esb.termQuery('type', 'publication'))
    const requestBody1 = esb.requestBodySearch()
        .query(boolQuery1)
        .trackTotalHits(true)
        .from(from)
        .size(6)
        .sort(esb.sort(ordreChamp, ordre));

    postData(urlRequete, requestBody1.toJSON()).then((data) => {
    
        totalAll += afficheResultats(data, 'publications')
        afficheNbrResultats(totalAll)
        if (data.hits.total.value > 6) document.querySelector('.lien-tout[data-type="publications"]').classList.add('is-active')

    });
  
    let boolQuery2 = esb.boolQuery().must(esb.multiMatchQuery(champsRecherche, input.value).type('best_fields').operator('and'));
    boolQuery2 = filtrerRequete(boolQuery2, themes,'expressions')
    boolQuery2.filter(esb.termQuery('type', 'article'))
    const requestBody2 = esb.requestBodySearch()
    .query(boolQuery2)
        .trackTotalHits(true)
        .from(from)
        .size(5)
      .sort(esb.sort(ordreChamp, ordre));

    postData(urlRequete, requestBody2.toJSON()).then((data) => {
        totalAll +=  afficheResultats(data, 'expressions')
        afficheNbrResultats(totalAll)
        if (data.hits.total.value > 5) document.querySelector('.lien-tout[data-type="expressions"]').classList.add('is-active')
 
    });
   
    // Toujours trier les auteurs par pertinence
    tri == 'pertinence'
    ordreChamp = '_score'
    ordre = 'desc'
    let boolQuery3 = esb.boolQuery().must(esb.multiMatchQuery(champsRecherche, input.value).type('best_fields').operator('and'));
    boolQuery3 = filtrerRequete(boolQuery3, themes,'experts')
    boolQuery3.filter(esb.termQuery('type', 'person'))
    const requestBody3 = esb.requestBodySearch()
        .query(boolQuery3)
        .trackTotalHits(true)
        .from(from)
        .size(8)
        .sort(esb.sort(ordreChamp, ordre));

      postData(urlRequete, requestBody3.toJSON()).then((data) => {
        totalAll += afficheResultats(data,'experts')
        afficheNbrResultats(totalAll)
    });

   

  } else {

    masqueLiensTout()

    from = page * nbrTypes[type]

    let boolQuery = esb.boolQuery().must(esb.multiMatchQuery(champsRecherche, input.value).type('best_fields').operator('and'));
    boolQuery = filtrerRequete(boolQuery, themes,type)
    boolQuery.filter(esb.termQuery('type', labelTypes[type]))
    size = nbrTypes[type]

    // Requete globale
    const requestBody = esb.requestBodySearch()
        .query(boolQuery)
        .trackTotalHits(true)
        .from(from)
        .size(size)
        .sort(esb.sort(ordreChamp, ordre));

    postData(urlRequete, requestBody.toJSON()).then((data) => {
       const result = afficheResultats(data, type, false)
       afficheNbrResultats ( data.hits.total.value)
    });

    //console.log(JSON.stringify(requestBody.toJSON()))
  }

}


const pagination = function (current,max,nbrAffiche) {
 

  var nbPages =  Math.ceil(max/nbrAffiche);

  if (nbPages > 1) {

    zonePagination.innerHTML = ''

    var div = document.createElement('div')
    div.classList.add('pagination')
    zonePagination.appendChild(div)

    if (current != 0) {
      var prev = document.createElement('a')
      prev.classList.add('pagination__prev')
      div.appendChild(prev)
    }

    for (let index = 1; index <= nbPages; index++) {
      var aPage = document.createElement('a')
      aPage.classList.add('pagination_page')
      aPage.dataset.page = index - 1
      aPage.innerHTML = index
      if (current == (index-1)) aPage.classList.add('is-active')
      div.appendChild(aPage)
      
    }
    if (current != (nbPages-1)) {
      var next = document.createElement('a')
      next.classList.add('pagination__next')
      div.appendChild(next)
    }
    
  }

}

// Ajouter les filtres de base à la requette
const filtrerRequete = function (query, themes,type) {
  query.filter(esb.termQuery('_language', langue))
  
  //query.filter(esb.termQuery('status', 1))
  if (themes.length > 0) {
    
    if (type == 'experts') {
      query.filter(esb.termsQuery('field_thematique_expert'+langueTheme, themes))
    }
     else {
      query.filter(esb.termsQuery('field_thematiques'+langueTheme, themes))
    }
  }

  if (type == 'experts') {
    query.filter(esb.termQuery('field_auteur_visible', true))
  }
   else {
    query.filter(esb.termQuery('field_indexation_du_contenu', 1))
  }

  return query
}

// Afficher les résultats dans les zones
const afficheResultats = function (data, type, all = true) {

  loader.classList.remove('is-active')

  const destination = document.querySelector('.resultats_' + type + ' .resultat-recherche')
  const sectionResultat = document.querySelector('.resultats_' + type )
  // Mise à jour du nombre de résultats
  var total = data.hits.total.value
  //afficheNbrResultats(total)

  var colType ="is-3"
  var colVariante = null
  // Affichage
  if (total > 0) {
    
    sectionResultat.classList.add('is-active')
    data.hits.hits.forEach((element,index) => {

      var frag = document.createRange().createContextualFragment(element._source.rendered_bloc[0])

      if (type=='publications') {
        if ( matricePublications.includes(index) ) colType = "is-6"
        else colType = "is-3"  

        afficheBloc(destination,frag,colType, colVariante )
      }
      if (type=='expressions') {
        if ( matriceExpressions.includes(index) ) {
            colType = "is-6"
            colVariante = 'bloc-expression--large'
        }
        else {
            colVariante = null
            if (all) colType = "is-4"  
            else colType = "is-6"  
        }
        afficheBloc(destination,frag,colType, colVariante )
      }
      if (type=='experts') {
        colType = "is-4"  
        colVariante = 'is-3-widescreen'
        destination.appendChild(frag)
      }
      

    });

    // Pagination
    if ((!all) && (total > nbrTypes[type])) {
      console.log('pagination')
      var paginationResultat = pagination(page,total,nbrTypes[type]) 
    } else zonePagination.innerHTML = ''
  } else {
    sectionResultat.classList.remove('is-active')
  }

  return total;
}

const afficheBloc = function (destination,frag,colType, colVariante=null ) {
  var col = document.createElement("div");
  col.classList.add('column')
  col.classList.add(colType)
  if (colVariante )col.classList.add(colVariante)
  col.appendChild(frag)
  destination.appendChild(col)
}


// Afficher le nombre de résultats total
const afficheNbrResultats = function (total) {
    if (langue == 'fr') nbrTotal.innerHTML = 'Il y a <strong>' + total + ' résultat' + s(total) + '</strong> pour votre recherche'
    else nbrTotal.innerHTML = 'There ' + is(total) + ' <strong>' + total + ' result' + s(total) + '</strong> for your searc'  
  }

// Lancer la requete
async function postData(url = "http://localhost:9200/elasticsearch_index_imv4_index_local/_search", data = {}) {

console.log(JSON.stringify(data))

  // Default options are marked with *
  const response = await fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
      'Authorization': 'Basic ' + btoa(pass)
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  });
  return response.json(); // parses JSON response into native JavaScript objects
}


const s = function (nbr) {
  if (nbr > 1) return 's'
  else return ''
}

const is = function (nbr) {
  if (nbr > 1) return 'is'
  else return 'are'
}
